import gql from 'graphql-tag';

/**
 * This query is designed to check the user's eligibility
 */
const GET_GWS_ELIGIBILITY_CHECK = gql`
  query checkGWSEligibility(
    $gwsType: GwsType!
    $program: Program
    $productId: String
  ) {
    me {
      checkUserEligibilityForGws(
        gwsType: $gwsType
        eligibilityRequest: { program: $program, productId: $productId }
      ) {
        globalFeatureOn
        gwsFeatureOn
        isEligible
        error
      }
    }
  }
`;

export default GET_GWS_ELIGIBILITY_CHECK;
